import { render, staticRenderFns } from "./account-table.vue?vue&type=template&id=3919222b&scoped=true&"
import script from "./account-table.ts?vue&type=script&lang=ts&"
export * from "./account-table.ts?vue&type=script&lang=ts&"
import style0 from "./account-table.scss?vue&type=style&index=0&id=3919222b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3919222b",
  null
  
)

export default component.exports